module.exports = __webpack_public_path__ + "img/55.0201b08d.png";